import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "calendar-v3-container" }
const _hoisted_2 = {
  key: 0,
  class: "calendar-header"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "separator",
  "data-v-f4c1337c": ""
}, null, -1)
const _hoisted_4 = { class: "calendar-page-wrapper" }
const _hoisted_5 = { class: "side-bar" }
const _hoisted_6 = { class: "calendar-wrapper pb-2" }
const _hoisted_7 = { class: "d-flex m-2 mx-3 hide-mobile" }
const _hoisted_8 = { class: "w-100 title" }
const _hoisted_9 = { class: "products-filter hide-mobile" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "calendar-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarSlotModal = _resolveComponent("CalendarSlotModal")!
  const _component_CalendarNewSlotModal = _resolveComponent("CalendarNewSlotModal")!
  const _component_CheckBoxInput = _resolveComponent("CheckBoxInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CalendarSlotModal, {
      products: _ctx.products,
      ref: "modal",
      onSave: _ctx.onSlotChanged
    }, null, 8, ["products", "onSave"]),
    _createVNode(_component_CalendarNewSlotModal, {
      products: _ctx.products,
      ref: "newModal",
      onSave: _ctx.selectSlotForOrder,
      onAddVirtualSlot: _ctx.addVirtualSlot
    }, null, 8, ["products", "onSave", "onAddVirtualSlot"]),
    (_ctx.selectSlotMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.getCurrecentProductName), 1),
          _hoisted_3,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("newOrder.addItemLabel")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            class: _normalizeClass(["d-none", { 'k-rtl': _ctx.isRTL }])
          }, null, 2),
          _createElementVNode("div", {
            ref: "calendarElement",
            class: _normalizeClass({ 'k-rtl': _ctx.isRTL })
          }, null, 2)
        ], 512), [
          [_vShow, _ctx.showCalendar]
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("calendar.v3.filter_product.title")), 1),
          (_ctx.products.length != _ctx.selectedProducts.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "k-button text-nowrap",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onFilter(true)))
              }, _toDisplayString(_ctx.$t("calendar.v3.filter_product.showall")), 1))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "k-button text-nowrap",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFilter(false)))
              }, _toDisplayString(_ctx.$t("calendar.v3.filter_product.hideall")), 1))
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (p) => {
            return (_openBlock(), _createBlock(_component_CheckBoxInput, {
              key: p.id,
              value: p.id,
              modelValue: _ctx.selectedProducts,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedProducts) = $event)),
                _ctx.onFilter
              ],
              singleLine: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(p.name), 1)
              ]),
              _: 2
            }, 1032, ["value", "modelValue", "onUpdate:modelValue"]))
          }), 128))
        ])
      ], 512), [
        [_vShow, !_ctx.selectSlotMode]
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", {
          class: _normalizeClass(["d-none", { 'k-rtl': _ctx.isRTL }])
        }, null, 2),
        _createElementVNode("div", {
          ref: "kendoWrapper",
          class: _normalizeClass({ 'k-rtl': _ctx.isRTL })
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, _toDisplayString(_ctx.$t("cashier.label.back")), 1)
    ])
  ]))
}